import HttpService from '../../services/HttpService';
import ErrorSwitchCase from '../../services/ErrorHandlerService';
import { SKILLS_PATH } from '../../url';
const _axios = HttpService.getAxiosClient();

export const addEmployeeSkill = async (skills) => {
  try {
    const response = await _axios.post(`${SKILLS_PATH}/employee`, skills);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const editEmployeeSkill = async (skills) => {
  try {
    const response = await _axios.put(`${SKILLS_PATH}/employee`, skills);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const getAllSkillsMapping = async (pageSize, pageNumber, filterData) => {
  try {
    const response = await _axios.get(
      `${SKILLS_PATH}/mappings?${pageSize ? 'pageSize=' + pageSize : ''}${
        pageNumber >= 0 ? '&pageNumber=' + pageNumber : ''
      }${filterData.employeeId ? '&employeeId=' + filterData.employeeId : ''}${
        filterData.status ? '&status=' + filterData.status : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const getApprovedSkills = async (currentUserId) => {
  try {
    const response = await _axios.get(`${SKILLS_PATH}/council/mappings`, {
      params: {
        employeeId: currentUserId,
      },
    });
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const approveSkill = async (reqBody) => {
  try {
    const response = await _axios.put(`${SKILLS_PATH}/council`, reqBody);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};
